export default __webpack_public_path__ + "static/media/Button2.718e1fc7.mp3";